import React from 'react';
import { createSvgIcon } from '@mui/material';

const CustomSortAscendOutlined = createSvgIcon(
  <path
    clipRule="evenodd"
    fillRule="evenodd"
    d="M14.353 19.692h-2.47c-.68 0-1.236-.588-1.236-1.307 0-.72.556-1.308 1.235-1.308h2.47c.68 0 1.236.588 1.236 1.308 0 .719-.556 1.307-1.235 1.307m-2.47-13.077c-.68 0-1.236-.588-1.236-1.307 0-.72.556-1.308 1.235-1.308h9.883C22.445 4 23 4.588 23 5.308c0 .719-.556 1.307-1.235 1.307zm6.176 6.539h-6.177c-.68 0-1.235-.589-1.235-1.308s.556-1.307 1.235-1.307h6.177c.68 0 1.235.588 1.235 1.307 0 .72-.556 1.308-1.235 1.308M4.155 18.615V8.064H2.468c-.412 0-.628-.582-.328-.916l2.615-2.995a.437.437 0 0 1 .665 0l2.614 2.995c.3.334.094.916-.328.916H6.03v10.551c0 .593-.422 1.077-.937 1.077s-.937-.484-.937-1.077Z"
  />,
  'CustomSortAscendOutlined',
);

export default CustomSortAscendOutlined;
